// extracted by mini-css-extract-plugin
export default {"content":"__fCrb6YRs7JofYeS3tM"};